'use client';

import Script from 'next/script';
import type { CohesionConfig } from '@highereducation/api-clients';
import { generateCohesionSnippet } from '@hen-site/lib/cohesion/generateCohesionSnippet';
import {
  isCohesionConfigValid,
  reportInvalidCohesionConfig,
} from '@hen-site/lib/cohesion/validateCohesionConfig';

type SnippetProps = {
  cohesionConfig: CohesionConfig;
};

export const Snippet = ({ cohesionConfig }: SnippetProps): React.ReactNode => {
  if (!isCohesionConfigValid(cohesionConfig)) {
    reportInvalidCohesionConfig(cohesionConfig);
  }

  const cohesionSnippet = generateCohesionSnippet(cohesionConfig);
  return (
    <Script
      id='script-cohesion'
      dangerouslySetInnerHTML={{
        __html: `${cohesionSnippet}`,
      }}
      strategy='beforeInteractive'
    />
  );
};
